import 'core-js';
// import utils from './utils';

const Zion = (name, url) => {
  const zionKeys = {
    Dev: 'KpBwC22cgTOQ5OFcXlXpBCcQ4T8dO1i6',
    Ref: '8t39z2GbZJqhKdMoQqsNiIv3DbTJtAWD',
    Stage: '6SJTYyRg7GWdXGtZb5Hf6vv0pWAIyPvG',
    Prod: 'mXFw59FFEpUNOu3aeVJChKAsqAlZ4NEf',
  };

  const detectEnvironment = () => {
    const url = window.location.href;
    if (url.indexOf('ix.cnn.io') > 0 || url.indexOf('www.cnn.com') > 0) {
      return 'Prod';
    }
    if (
      url.indexOf('cnnpreview') > 0
            || url.indexOf('cnn-interactive') > 0
    ) {
      return 'Stage';
    }
    return 'Dev';
  };

  // const isMobileDevice = utils.mobileAndTabletCheck();
  // const isMobile = window.innerWidth < 800 || isMobileDevice;
  const zionEnv = detectEnvironment();

  const zion_config_url = 'https://zion.cnn.com/2.0/';
  // this does the async load of the sdk
  const d = document;
  const g = d.createElement('script');
  const s = d.getElementsByTagName('script')[0];
  g.type = 'text/javascript';
  g.defer = true;
  g.async = true;
  g.src = `${zion_config_url}zion-suite.min.js`;
  s.parentNode.insertBefore(g, s);
  // wait for the sdk to be loaded to setup things
  g.onload = function () {
    // create a handle for the zion analytics object
    window.zion_analytics = new window.ZION_SDK.ZionAnalytics(
      window.ZION_SDK.ClientType.Web, // * legacy, this will always be Web
      window.ZION_SDK.EnvironmentType[zionEnv], // Identity bridge value. See https://github.com/turnercode/zion-suite/tree/master/packages/ZionAnalytics#parameters for values
      {
        enabled: true, // Analytics functionality flag
        bridgeEnabled: true, // Id bridge functionality flag
        // enableLogging: true, // this turns on and off debug logs
        accessKey: zionKeys[zionEnv], // This is the appropriate Key for segment, Ask the Data core team for the keys if you do not have them
      },
    );
    window.zion_analytics.track(
      new window.ZION_SDK.Pageview({
        // contact data core if your not sure what values to use
        sourceId: `graphic_${name}`,
        hypatiaId: 'h_1',
        canonicalUrl: url,
      }),
    );
  };
};

export default Zion;
